<template>
  <el-dialog title="设置小组" :visible.sync="visible" width="800px" center custom-class="default-table">
    <div>
      <el-select class="el-input-c" v-model="form.organization_id" placeholder="请选择小组" style="width: 100%"
                 filterable>
        <el-option v-for="item in organizationOptions" :key="item.id" :value="item.id" :label="item.label"/>
      </el-select>
      <el-table :data="orders" style="width: 100%;margin-top: 20px;">
        <el-table-column prop="order_no" label="订单编号" width="180"/>
        <el-table-column prop="payment_account" label="含税收入" header-align="center" align="right"/>
        <el-table-column prop="sale_name" label="销售"/>
        <el-table-column prop="organization_name" label="当前小组"/>
        <el-table-column prop="created_timestamp_alias" label="下单时间" width="180"/>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="handelSure" size="mini">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
import {options} from "@/api/organization";
import {transferOrganization} from "@/api/adOrder";

export default {
  name: "DistributeOrganization",
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    orders: {
      type: Array,
      required: true
    }
  },
  watch: {
    show: function (v) {
      if (v) {
        this.visible = v
      }
    },
    visible: function (v) {
      if (!v) {
        this.$emit('update:show', false)
      }
    }
  },
  data() {
    return {
      visible: this.show,
      organizationOptions: [],
      form: {
        organization_id: null
      }
    }
  },
  mounted() {
    this.getTeamList()
  },
  methods: {
    async handelSure() {
      if (!this.form.organization_id) {
        this.$message.warning('请选择小组');
        return false;
      }
      const order_nos = this.orders.map(_ => {
        return _.order_no
      })
      const that = this;
      const response = await transferOrganization({organization_id: this.form.organization_id, order_nos});
      if (!response.success) {
        this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
      this.visible = false
      this.$emit('success')
    },
    // 获取小组列表
    getTeamList() {
      options().then(res => {
        if (!res.success) {
          this.$message.error(res.message);
          return
        }
        this.organizationOptions = res.model;
      })
    },
  }
}
</script>

<style scoped>

</style>
